import { render, staticRenderFns } from "./VerifyWithdrawal.vue?vue&type=template&id=16a1e7a3&scoped=true"
import script from "./VerifyWithdrawal.vue?vue&type=script&lang=js"
export * from "./VerifyWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./VerifyWithdrawal.vue?vue&type=style&index=0&id=16a1e7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1e7a3",
  null
  
)

export default component.exports